import {SchoolTicketsTable} from "@/modules/tickets/pages/schools/components/SchoolTicketsTable";
import PageHeader from "@/global/components/PageHeader";
import {wrapperSx} from "@/global/helpers/globalstyles";
import React from "react";
import {Box, Button, Stack, Typography} from "@mui/material";
import {useSchoolStore} from "@/School/store/SchoolStore";
import {Link, useParams} from "react-router-dom";

export function SchoolTicketsPage() {
    const schoolTitle = useSchoolStore((state) => state.title);
    const params = useParams();
    return (
        <Box
            className="App"
            sx={{height: '100%', display: 'flex', flexDirection: 'column', pb: 3}}
        >
            <PageHeader/>
            <Box sx={wrapperSx}>
                <Typography
                    variant={'h5'}
                    sx={{
                        marginTop: 2,
                    }}
                >
                    Обращение в техподдержку, связанные с автошколой
                    {' '}
                    {schoolTitle}
                </Typography>
                <Stack>
                    <Button
                        component={Link}
                        variant={'contained'}
                        sx={{
                            marginLeft: 'auto',
                            marginTop: 2,
                            marginBottom: 2,
                        }}
                        to={`/schools/${params['id']}/new-ticket`}
                    >
                        Создать новое обращение
                    </Button>
                </Stack>
                <SchoolTicketsTable school_id={params['id'] ? +params['id'] : undefined} />
            </Box>
        </Box>
    );
}